
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.47 1.47a.75.75 0 011.06 0l3 3a.75.75 0 01-1.06 1.06L8 3.06 5.53 5.53a.75.75 0 01-1.06-1.06l3-3zM8.53 14.53a.75.75 0 01-1.06 0l-3-3a.75.75 0 111.06-1.06L8 12.94l2.47-2.47a.75.75 0 111.06 1.06l-3 3z","fill":"#353333"}})])
          )
        }
      }
    